
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingOverlay",
  props: {
    display: Boolean,
  },
});
